import DataTable from "./DataTable";

import { humanize } from "../lib/labels";

export interface PivotTableProps {
  rowKey: string;
  colKey: string;
  measureKey: string;
  rows: Record<string, string | number | null>[];
}

/**
 * Pivot widget. Maps to manifest chart_type=pivot. Phase 1 stub
 * delegates to DataTable; Phase 4 will implement true row x column
 * pivoting (probably with a small in-memory aggregation since the
 * underlying Postgres view should already shape the data).
 */
export default function PivotTable(props: PivotTableProps) {
  const { rowKey, colKey, measureKey, rows } = props;
  const colSet = new Set<string>();
  for (const r of rows) {
    const c = r[colKey];
    if (c !== null && c !== undefined) colSet.add(String(c));
  }
  const cols = Array.from(colSet).sort();

  const rowGroups = new Map<string, Record<string, number>>();
  for (const r of rows) {
    const rk = String(r[rowKey] ?? "");
    const ck = String(r[colKey] ?? "");
    const mv = Number(r[measureKey] ?? 0);
    if (!rowGroups.has(rk)) rowGroups.set(rk, {});
    const bucket = rowGroups.get(rk);
    if (bucket) bucket[ck] = (bucket[ck] ?? 0) + mv;
  }

  const tableRows: (string | number | null)[][] = [];
  for (const [rk, bucket] of rowGroups) {
    // MER-438: humanize the row-dimension label so a customer sees "Front Load",
    // not the raw "front_load" enum.
    const row: (string | number | null)[] = [humanize(rk)];
    for (const c of cols) row.push(bucket[c] ?? 0);
    tableRows.push(row);
  }

  // MER-438: humanize the row-key + pivoted column headers (raw snake_case
  // / enum values otherwise leak as machine names).
  return (
    <DataTable
      columns={[humanize(rowKey), ...cols.map((c) => humanize(c))]}
      rows={tableRows}
      pagination={false}
    />
  );
}
